$(function() {
    if ($('.hrg-ce-before-after').length === 0) return;

    $('.hrg-ce-before-after').each(function() {
        const slider = this;
        const inner = slider.querySelector('.before-after-inner');
        const range = slider.querySelector('.before-after-range');

        const setPosition = function(value) {
            const position = Math.min(100, Math.max(0, value));
            slider.style.setProperty('--position', position + '%');
            range.value = Math.round(position);
        };

        const setPositionFromPointer = function(event) {
            const rect = inner.getBoundingClientRect();
            setPosition((event.clientX - rect.left) / rect.width * 100);
        };

        const stopDragging = function(event) {
            if (!inner.classList.contains('is-dragging')) return;

            inner.classList.remove('is-dragging');
            if (inner.hasPointerCapture(event.pointerId)) {
                inner.releasePointerCapture(event.pointerId);
            }
        };

        inner.addEventListener('pointerdown', function(event) {
            if (event.button !== 0) return;

            inner.classList.add('is-dragging');
            inner.setPointerCapture(event.pointerId);
            setPositionFromPointer(event);
        });

        inner.addEventListener('pointermove', function(event) {
            if (!inner.classList.contains('is-dragging')) return;

            setPositionFromPointer(event);
        });

        inner.addEventListener('pointerup', stopDragging);
        inner.addEventListener('pointercancel', stopDragging);

        // Tastaturbedienung über das versteckte Range-Input
        range.addEventListener('input', function() {
            setPosition(parseFloat(range.value));
        });
    });
});
